import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { PageHero } from "@/components/site/Reveal";
import DemandeForm from "@/components/site/DemandeForm";
import { COMPANY } from "@/data/site";
import usePageMeta from "@/hooks/usePageMeta";

const META = {
  devis: { t: "Demande de devis", e: "Devis gratuit", h: "Obtenez votre devis personnalisé.", x: "Décrivez votre besoin, nous revenons vers vous rapidement avec une proposition sur mesure.", img: "/images/logement.jpg" },
  rdv: { t: "Prise de rendez-vous", e: "Rendez-vous", h: "Planifions ensemble votre rendez-vous.", x: "Visite d'évaluation, état des lieux ou première rencontre : choisissez une date et un créneau.", img: "/images/cles.jpg" },
  contact: { t: "Contact", e: "Contact", h: "Appelez ou écrivez-nous.", x: "Pour un devis ou une demande d'information personnalisée.", img: "/images/port.jpg" },
};

const Coordonnees = () => (
  <aside className="space-y-5 rounded-lg bg-[#0F2840] p-8 text-white" data-testid="coordonnees">
    <h2 className="font-display text-2xl">Nos coordonnées</h2>
    {[[Phone, <a key="t" href={COMPANY.telephoneHref} className="underline-offset-4 hover:underline" data-testid="contact-phone-link">{COMPANY.telephone}</a>], [Mail, <a key="m" href={`mailto:${COMPANY.email}`} className="underline-offset-4 hover:underline" data-testid="contact-email-link">{COMPANY.email}</a>], [MapPin, COMPANY.adresse], [Clock, <span key="h" data-testid="contact-horaires">{COMPANY.horaires}</span>]].map(([I, v], k) => (
      <p key={k} className="flex gap-3 text-sm text-white/85"><I className="h-5 w-5 shrink-0 text-[#ff8080]" />{v}</p>
    ))}
    <div className="h-2 stripe-mariniere opacity-60" />
    <p className="text-xs text-white/60">Zone d'intervention : Brest et le Finistère. Courrier : {COMPANY.siege} (domiciliation commerciale et postale, sans accueil du public).</p>
  </aside>
);

export default function DemandePage({ type }) {
  const m = META[type];
  usePageMeta(m.t, `${m.t} – Conciergerie Familly 29 à Brest. ${m.x}`);
  return (
    <>
      <PageHero testid={`${type}-hero`} eyebrow={m.e} title={m.h} text={m.x} image={m.img} />
      <section className="mx-auto grid max-w-7xl gap-12 px-5 py-20 md:grid-cols-12 lg:px-8">
        <div className="md:col-span-8"><DemandeForm type={type} /></div>
        <div className="md:col-span-4"><Coordonnees /></div>
      </section>
    </>
  );
}
